var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-flex"},[_c(_vm.tag,_vm._g({tag:"component",class:[_vm.className, _vm.colorClassName],attrs:{"disabled":_vm.disabled,"type":_vm.type,"to":_vm.to}},_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }